<template>
  <div>
    <TdbHeader
      :is-utilisateur-agrial="isUtilisateurAgrial"
      class="mx-0 mx-md-2 mt-2"
    />
    <BaseLoader v-if="loadingInit && ((isUtilisateurAgrial && adherent.raisonSociale!= null) || !isUtilisateurAgrial)" />
    <!-- TDB Conseiller -->
    <v-row
      v-if="!loadingInit && isUtilisateurAgrial && numtiersSelected == null"
      :class="$vuetify.breakpoint.mobile ? 'flex-column mt-3' : ''"
      no-gutters
    >
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'px-2'"
        cols="12"
        md="6"
      >
        <DecouverteConseiller
          class="eq-height"
        />
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? '' : 'px-2'"
        cols="12"
        md="6"
      >
        <BaseCardV2
          :titre="'simulateur de prix d\'équilibre'"
          class="eq-height"
          has-help
          
          @on-help="isOpenModalSimulateurPrixEquilibre = true"
        >
          <SimulateurPrixEquilibre
            :is-utilisateur-agrial="isUtilisateurAgrial"
            :numtiers-selected="numtiersSelected"
            class="mt-5 mx-5"
          />
        </BaseCardV2>
      </v-col>
    </v-row>

    <!-- TDB Adhérent avec apports et/ou contrats-->
    <div v-if="!loadingInit && ((isUtilisateurAgrial && adherent.raisonSociale!= null) || !isUtilisateurAgrial) && ((grainesContractualiseesEtRecoltees!= null && grainesContractualiseesEtRecoltees.length > 0) || assolement!= null && assolement.length > 0)">
      <div
        :class="$vuetify.breakpoint.mobile ? 'flex-column mt-3' : ''"
        class="d-flex"
      >
        <BaseSelectAnneeRecolte
          :liste-annees-recoltes="listeAnneesRecoltes"
          :liste-graines-a-afficher="grainesContractualiseesEtRecoltees"
          :code-graine-selected="codeGraineActive"
          :loading="loading.cultures"
          @selectAnneeRecolte="selectAnneeRecolte"
          @selectGraine="selectGraine"
        />
      </div>
      <AdherentRebond
        v-if="redirection && !isBandeauParametreManquantAffiche"
        :path-origine="pagePath"
        :redirection="redirection"
        class="mt-4"
        is-on-tdb
      />
      <v-card
        v-if="isBandeauParametreManquantAffiche"
        :class="$vuetify.breakpoint.mobile ? 'flex-column pa-3' : 'mr-2'"
        class="my-4"
        @click="toCompte()"
      >
        <div class="d-flex justify-center">
          <div class="align-self-center">
            <img
              alt="no-comparaison"
              class="picto mt-2"
              src="@/assets/no-comparaison.svg"
            >
          </div>
          <div
            :class="$vuetify.breakpoint.mobile ? 'flex-column ml-3' : ''"
            class="d-flex"
          >
            <div
              :class="
                $vuetify.breakpoint.mobile ? 'mt-3' : 'mx-3 align-self-center '
              "
            >
              <v-chip
                color="#EC6608"
                label
              >
                <span class="texte white--text"> Non renseigné</span>
              </v-chip>
            </div>
            <div class="align-self-center intro text-gris-fonce mt-1">
              Complétez vos paramètres d'exploitation pour profiter pleinement de l'outil.
            </div>
          </div>
          <div class="align-self-center">
            <v-icon class="ml-1">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>
      </v-card>
      <v-row
        class="mt-5"
        no-gutters
      >
        <v-col
          :class="$vuetify.breakpoint.mobile ? 'pb-1' : 'pr-4 pb-4'"
          cols="12"
          md="4"
        >
          <BaseCardV2
            :btn-action="{
              libelle: 'Voir mes contrats',
              to: {
                name: 'main.mes-contrats'
              }}
            "
            :btn-v-badge="nbNouveauxContrats"
            :titre="'répartition de mes contrats'"
            has-help
            @on-help="isOpenModalRepartitionContrat = true"
          >
            <RepartitionContrats
              :is-utilisateur-agrial="isUtilisateurAgrial"
              class="mx-5"
            />
          </BaseCardV2>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.mobile && isAffichageLegendeAsterix"
          class="pa-1 pa-md-3 pt-0"
          cols="12"
        >
          <v-col cols="12">
            <span
              class="asterix"
            >* Evolution par rapport à l’année précédente
            </span>
          </v-col>
        </v-col>
        <v-col
          :class="$vuetify.breakpoint.mobile ? '' : 'pr-4'"
          class="pb-4"
          cols="12"
          md="4"
        >
          <BaseCardV2
            :titre="'avancée de ma commercialisation'"
            has-help
            @on-help="isOpenModalCommercialisation = true"
          >
            <Commercialisation
              class="mx-4 mx-md-5 mt-5"
            />
          </BaseCardV2>
        </v-col>
        <v-col
          class="pb-4"
          cols="12"
          md="4"
        >
          <BaseCardV2
            :btn-action="{
              libelle: 'Voir mes apports',
              to: {
                name: 'main.mes-recoltes'
              }}
            "
            :btn-v-badge="nbNewApport"
            :titre="'Poids total livré'"
            has-help
            @on-help="isOpenModalPoidsTotalLivre = true"
          >
            <Apports
              :is-utilisateur-agrial="isUtilisateurAgrial"
              class="mx-5"
              @new-apport-consultation="getNewApportConsultation"
            />
          </BaseCardV2>
        </v-col>
        <v-col
          :class="$vuetify.breakpoint.mobile ? 'pb-1' : 'pr-4 pb-4'"
          cols="12"
          md="4"
        >
          <BaseCardV2
            :btn-action="btnActionOutilsAnalyse"
            :chip="displayChipPrixFerme ? {libelle: 'Prix ferme'} : null "
            titre="Mes outils d'analyse"
            @otherAction="isOpenModaleCulturesManquantes = true"
          >
            <RepartitionPrixContratMoyen
              class="mx-5"
              @checkIfData="hasDonneesPrixFerme"
            />
          </BaseCardV2>
        </v-col>
        <v-col
          :class="$vuetify.breakpoint.mobile ? 'pt-3' : 'pr-4'"
          class="pb-4"
          cols="12"
          md="4"
        >
          <BaseCardV2
            :btn-action="{
              libelle: 'Voir mes cultures',
              to: {
                name: 'main.mes-cultures'
              }}
            "
            :titre="'mes cultures'"
            has-help
            @on-help="isOpenModalMesCultures = true"
          >
            <Cultures
              class="mx-5"
            />
          </BaseCardV2>
        </v-col>
        <v-col
          :class="$vuetify.breakpoint.mobile ? 'mb-10' : 'pr-4'"
          class="pb-4"
          cols="12"
          md="4"
        >
          <BaseCardV2
            v-if="loading.atelierCultureVerrouillage"
            :loading="loading.atelierCultureVerrouillage"
          />
          <BaseCardV2
            v-else-if="(!hasClotureVerrouillee || displaySimulateur) && !loading.atelierCultureVerrouillage"
            :btn-action="displaySimulateur ? btnActionDisplaySimulateur : {
              libelle: 'Voir mon prix réel',
              icon: abonnements.culturialAbonne ? '' : 'mdi-lock',
              hasOtherAtion: true
            }"
            :titre="'simulateur de prix d\'équilibre'"
            has-help
            @otherAction="!displaySimulateur ? isOpenModalAideInformationAbonnement = true : displaySimulateur = false"
            @on-help="isOpenModalSimulateurPrixEquilibre = true"
          >
            <SimulateurPrixEquilibre
              :is-utilisateur-agrial="isUtilisateurAgrial"
              :numtiers-selected="numtiersSelected"
              class="mt-5 mx-5"
            />
          </BaseCardV2>
          <BaseCardV2
            v-else-if="(hasClotureVerrouillee || !displaySimulateur) && !loading.atelierCultureVerrouillage"
            :btn-action="btnActionOutilsAnalyse"
            :btn-action-secondaire="btnActionDisplaySimulateur"
            :titre="'Mon prix d\'équilibre'"
            @avant-navigation="deposerCultureSelectionnee"
            @otherAction="displaySimulateur = !displaySimulateur"
          >
            <PrixEquilibre
              :is-utilisateur-agrial="isUtilisateurAgrial"
              :numtiers-selected="numtiersSelected"
              class="mt-5 mx-5"
              @culture-selectionnee="codeCultureSelectionnee = $event"
            />
          </BaseCardV2>
        </v-col>
      </v-row>
      <v-row v-if="!$vuetify.breakpoint.mobile">
        <v-col
          cols="12"
          offset="5"
        >
          <span
            class="asterix"
          >* Evolution par rapport à l’année précédente
          </span>
        </v-col>
      </v-row>
    </div>
    <!-- TDB Adhérent sans apports ni contrats-->
    <Decouverte
      v-if="!loadingInit && ((isUtilisateurAgrial && numtiersSelected != null) || !isUtilisateurAgrial) && grainesContractualiseesEtRecoltees!= null && grainesContractualiseesEtRecoltees.length === 0"
      class="mb-14"
    />

    <HelpModal
      v-if="isOpenModalRepartitionContrat"
      titre="répartition de mes contrats"
      :is-open-modal-help="isOpenModalRepartitionContrat"
      @close="isOpenModalRepartitionContrat = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Visualisez ici la répartition de vos tonnages et de vos prix moyens contractualisés en fonction du type de contrat.</p>
          <p>Certains contrats n’ont pas de prix (ex : contrats échanges). Dans ce cas, aucun prix n’est affiché dans la légende.</p>
          <p>Le prix moyen affiché correspond à une moyenne pondérée des prix de base de vos contrats et non au prix payé.</p>
        </div>
      </div>
    </HelpModal>
    <HelpModal
      v-if="isOpenModalCommercialisation"
      :is-open-modal-help="isOpenModalCommercialisation"
      titre="avancée de ma commercialisation"
      @close="isOpenModalCommercialisation = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Retrouvez ici un état des lieux de votre commercialisation et de vos stocks de grains auprès d'Agrial, pour la graine et l'année sélectionnée.</p>
          <p>Les valeurs sont arrondies sauf si elles sont inférieures à 1t, où elles sont détaillées jusqu'à 3 décimales.</p>
        </div>
      </div>
    </HelpModal>
    <HelpModal
      v-if="isOpenModalPoidsTotalLivre"
      :is-open-modal-help="isOpenModalPoidsTotalLivre"
      titre="Poids total livré"
      @close="isOpenModalPoidsTotalLivre = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Visualisez ici le poids total livré aux normes en fonction de l’année de récolte et de la graine sélectionnée.</p>
          <p>Si vous souhaitez plus de détails sur vos apports, cliquez sur "voir mes apports".</p>
        </div>
      </div>
    </HelpModal>
    <HelpModal
      v-if="isOpenModalMesCultures"
      :is-open-modal-help="isOpenModalMesCultures"
      titre="mes cultures"
      @close="isOpenModalMesCultures = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Visualisez ici la surface totale en lien avec votre graine de commercialisation.</p>
          <p>Vous pouvez la renseigner ou la modifier en cliquant sur le bouton "Voir mes cultures".</p>
          <p>Vous pourrez ensuite comparer vos rendements avec les autres adhérents de la coopérative.</p>
        </div>
      </div>
    </HelpModal>
    <HelpModal
      v-if="isOpenModalSimulateurPrixEquilibre"
      :is-open-modal-help="isOpenModalSimulateurPrixEquilibre"
      titre="simulateur de prix d'équilibre"
      @close="isOpenModalSimulateurPrixEquilibre = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p v-if="!isUtilisateurAgrial">
            Cette carte est un simulateur de prix d'équilibre, positionné sur des valeurs moyennes historiques. Elles ne reflètent en rien les chiffres de votre exploitation.
          </p>
          <p>
            Certaines données peuvent considérablement différer d'une exploitation à une autre. La démarche technico-économique peut vous accompagner pour une approche individuelle chez vos adhérents.
          </p>
          <p>Si vous faîtes varier les montants pour voir l'impact sur votre prix d'équilibre, vous retrouverez ces mêmes données à votre prochaine connexion.</p>

          <p>Le prix d'équilibre est calculé selon la formule suivante :</p>
          <img
            alt="Formule - Calcul prix équilibre"
            class="formule-img"
            src="@/assets/math/reperes-economiques-prix-equilibre-math.png"
          >
          <p>Les rendements sont exprimés en quintaux par hectare.</p>
          <p>
            Les charges intrants correspondent aux charges engrais, semences et
            traitement.
          </p>
          <p>
            Les charges fixes incluent l'ensemble des autres charges hors
            rémunération. On soustrait de ces charges les aides PAC, les co-produits (ex : vente paille) et les autres produits (ex : ristournes, aides région, subventions, …).
          </p>
        </div>
      </div>
    </HelpModal>
    <InfoModal
      v-if="isOpenModaleCulturesManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleCulturesManquantes"
      @close="isOpenModaleCulturesManquantes = false"
      @confirm="toPageCulture()"
    >
      <CultureManquanteContentModal />
    </InfoModal>
    <InformationAbonnementModal
      v-if="isOpenModalAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
      code-feature="PRIX_EQUILIBRE"
      texte="Obtenez votre prix d'équilibre en €/t de chacune de vos cultures de vente grâce à l'accompagnement d'un expert technico-économique."
      titre="Prix d'équilibre réel"
      @close="isOpenModalAideInformationAbonnement = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { sum } from 'lodash'
import AdherentRebond from '@/views/admin/rebond/components/adherent-rebond.vue'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import TdbHeader from './components/tdb-header.vue'
import BaseSelectAnneeRecolte from '@/components/common/base-select-annee-recolte.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import RepartitionContrats from './components/repartition-contrats.vue'
import RepartitionPrixContratMoyen from './components/repartition-prix-contrat-moyen.vue'
import SimulateurPrixEquilibre from './components/simulateur-prix.vue'
import Cultures from './components/cultures.vue'
import Apports from './components/apports.vue'
import Commercialisation from './components/commercialisation.vue'
import Decouverte from './components/decouverte.vue'
import DecouverteConseiller from './components/decouverte-conseiller.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import CultureManquanteContentModal from '@/views/cultures/components/modal/culture-manquante-content-modal.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import PrixEquilibre from './components/prix-equilibre.vue'

export default {
  name: 'TableauDeBord',
  components: { AdherentRebond, BaseCardV2, BaseLoader, HelpModal, InfoModal, CultureManquanteContentModal, InformationAbonnementModal, BaseSelectAnneeRecolte, PrixEquilibre, TdbHeader, RepartitionContrats, RepartitionPrixContratMoyen, SimulateurPrixEquilibre, Cultures, Apports, Commercialisation, Decouverte, DecouverteConseiller },
  props: {
    loadingInit: {
      type: Boolean,
      default: false
    },
    numtiersSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: {
        cultures: false,
        atelierCultureVerrouillage: false
      },
      erreur: {
        atelierCultureVerrouillage:false
      },
      pagePath: 'main.tableau-de-bord',
      isOpenModalRepartitionContrat: false,
      isOpenModalCommercialisation: false,
      isOpenModalPoidsTotalLivre: false,
      isOpenModalMesCultures: false,
      isOpenModalSimulateurPrixEquilibre: false,
      codeCultureSelectionnee: null,
      isOpenModaleInfosManquantes: false,
      isOpenModaleCulturesManquantes: false,
      isOpenModalAideInformationAbonnement: false,
      nbNewApport: 0,
      displayChipPrixFerme: false,
      displaySimulateur: false
    }
  },

  computed: {
    ...mapGetters({
      isUtilisateurAgrial: 'user/isUtilisateurAgrial',
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive',
      adherent: 'adherent/adherent',
      abonnements: 'adherent/abonnements',
      listeAnneesRecoltes: 'recolte/listeAnneesRecoltes',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
      redirection: 'redirection/redirection',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      nbNouveauxContrats: 'contrat/nbNouveauxContrats',
      assolement: 'assolement/assolement',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage'
    }),

    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage?.isAtelierVerrouille
    },

    culturesSelected () {
      let result = []
      for (let i = 0; i < this.assolement.length; i++ ) {
        if (this.codeGraineActive !== null && this.assolement[i].codesRs3Correspondants.includes(this.codeGraineActive)) {
          result.push({ surface: this.assolement[i].surfaceEnHectare })
        }
      }
      return result
    },
    surfaceTotaleGraineSelected () {
      return sum(this.culturesSelected.flatMap(c => c.surface))
    },
    btnActionOutilsAnalyse () {
      return {
        libelle: 'Voir mon analyse',
        hasOtherAtion: !this.surfaceTotaleGraineSelected>0,
        to: { name: 'main.mes-outils-d-analyse' }
      }
    },
    btnActionDisplaySimulateur () {
      return {
        libelle: this.displaySimulateur ? 'Fermer le simulateur' : 'Afficher le simulateur',
        isOutlined: true,
        icon: 'mdi-close',
        hasOtherAtion: true
      }
    },
    isAffichageLegendeAsterix () {
      return this.grainesContractualiseesEtRecoltees!= null && this.grainesContractualiseesEtRecoltees.length > 0
    },
    isBandeauParametreManquantAffiche () {
      return ((this.isUtilisateurAgrial && this.adherent.full) || !this.isUtilisateurAgrial) && !this.isParametresExploitationComplet && (this.grainesContractualiseesEtRecoltees != null && this.grainesContractualiseesEtRecoltees.length !== 0)
    }
  },

  watch: {
    numtiersSelected (numtiers) {
      if (numtiers != null) {
        this.getRedirection(this.pagePath)
        this.reloadCultures()
      }
    }
  },

  created () {
    if (!this.isUtilisateurAgrial || (this.isUtilisateurAgrial && this.numtiersSelected != null)) {
      this.getRedirection(this.pagePath)
      this.reloadCultures()
    }
  },

  methods: {
    ...mapActions({
      getRedirection: 'redirection/getRedirection',
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      getGrainesContractualiseesEtRecoltees: 'graine/getGrainesContractualiseesEtRecoltees',
      getAtelierCultureVerrouillage:'cloture/getAtelierCultureVerrouillage',
      demanderCulture: 'culture/demanderCulture'
    }),

    deposerCultureSelectionnee () {
      this.demanderCulture(this.codeCultureSelectionnee)
    },

    displayAideParametresCompte () {
      this.$cookies.set('DISPLAY_AIDE_PARAMETRES_COMPTE', 1)
    },
    selectAnneeRecolte (value) {
      this.loading.atelierCultureVerrouillage = true
      this.updateAnneeRecolteActive(value)
        .then(() => {
          this.reloadCultures()
        })
    },
    selectGraine (value) {
      this.updateCodeGraineActive(value)
    },
    getNewApportConsultation (nbNewApport) {
      this.nbNewApport = nbNewApport
    },
    hasDonneesPrixFerme (value) {
      this.displayChipPrixFerme = value
    },
    toCompte () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.compte' })
    },
    toPageCulture () {
      this.isOpenModaleCulturesManquantes = false
      this.$router.push({ name: 'main.mes-cultures' })
    },
    loadAtelierCultureVerrouillage () {
      this.loading.atelierCultureVerrouillage = true
      this.erreur.atelierCultureVerrouillage = false
      this.getAtelierCultureVerrouillage()
        .catch(() => {
          this.erreur.atelierCultureVerrouillage = true
        })
        .finally(() => {
          this.loading.atelierCultureVerrouillage = false
        })

    },
    reloadCultures () {
      this.loading.cultures = true
      const anneeInitiale = this.anneeRecolteActive || this.anneeRecolteEnCours
      this.getGrainesContractualiseesEtRecoltees(anneeInitiale)
        .then(() => {
          if (this.grainesContractualiseesEtRecoltees.length === 0) {
            const anneePrecedente = Number(anneeInitiale) - 1
            
            if (typeof this.updateAnneeRecolteActive === 'function') {
              this.updateAnneeRecolteActive(anneePrecedente)
            } else {
              this.anneeRecolteActive = anneePrecedente
            }

            return this.getGrainesContractualiseesEtRecoltees(anneePrecedente)
          }
        })
        .then(() => {
          if (this.grainesContractualiseesEtRecoltees.length === 0) {
            this.updateCodeGraineActive(null)
          } else if (this.grainesContractualiseesEtRecoltees.filter(g => g.code === this.codeGraineActive).length === 0) {
            this.updateCodeGraineActive(this.grainesContractualiseesEtRecoltees[0].code)
          } else {
            this.updateCodeGraineActive(this.codeGraineActive)
          }
          this.loadAtelierCultureVerrouillage()
        })
        .finally(() => {
          this.loading.cultures = false
        })
    }
  }
}
</script>

<style lang="scss">
.formule-img {
  width: 100%;
}

.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
.picto {
  width: 5.5em;
}
</style>
